import React, { useCallback, useMemo } from 'react';
import { TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { setElementFocusedState } from '../../../redux/modules/global';
import useDeviceResize from '../../../hooks/useDeviceResize';
import FieldLabel from '../../ValidationFormElements/FieldLabel';

const MainTextField = (props) => {
  const dispatch = useDispatch();
  const isDeviceLgSize = useDeviceResize('lg');
  const { label, required } = props;

  const onFocus = useCallback(() => {
    if (isDeviceLgSize) {
      dispatch(setElementFocusedState(true));
    }
  }, [dispatch, isDeviceLgSize]);

  const onBlur = useCallback(() => {
    if (isDeviceLgSize) {
      dispatch(setElementFocusedState(false));
    }
  }, [dispatch, isDeviceLgSize]);

  const commonProps = useMemo(() => {
    const data = { ...props };
    // Here we delete {required} key, because we have already {FieldLabel} props with component
    delete data.required;

    return data;
  }, [props]);

  return (
    <TextField
      {...commonProps}
      onBlur={onBlur}
      onFocus={onFocus}
      label={<FieldLabel labelKey={label} required={required} />}
    />
  );
};

MainTextField.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
};

MainTextField.defaultProps = {
  label: '',
  required: false,
};

export default MainTextField;
